import { Component, Input } from '@angular/core';
import { Validators, UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ApiService } from 'src/app/api.service';
import { FunctionsService } from 'src/app/services/functions.service';
import { TranslateService } from '@ngx-translate/core';
import { OkModalComponent } from 'src/app/generic-components/ok-modal/ok-modal.component';
import { NgxSpinnerService } from 'ngx-spinner';
import { AppConstants } from 'src/app/app.constants';

@Component({
  selector: 'app-add-activity',
  templateUrl: './add-activity.component.html',
  styleUrls: ['./add-activity.component.css'],
  providers: [NgxSpinnerService]
})

export class AddActivityComponent {
  @Input() set alertInfo(value: any) {
    this.alertId = value;
  }

  constructor(
    public functionsService: FunctionsService,
    public activeModal: NgbActiveModal,
    private modalService: NgbModal,
    private apiService: ApiService,
    private spinner:NgxSpinnerService,
    public translate:TranslateService) { }

  alertId: any;
  formSubmitted: boolean = false;
  owner = false;

  addActivityForm = new UntypedFormGroup({
    Note: new UntypedFormControl('', Validators.compose([
        Validators.required,
        Validators.maxLength(250),
        Validators.pattern(AppConstants.noLeadingRegEx)
    ]))
  });
  
  addActivity(){
    this.addActivityForm.value["Note"] = this.addActivityForm.value["Note"]?this.addActivityForm.value["Note"].trim():"";
      
    if (!this.addActivityForm.valid) {
        this.formSubmitted = true;
        return;
    } 
    this.spinner.show();
    this.addActivityForm.value["AlertId"] = this.alertId;
    this.apiService.addAlertNote(this.addActivityForm.value).subscribe(
        () => {
          this.spinner.hide();
          this.activeModal.close();
        },
        error => {
          this.spinner.hide();
          if(error["error"]["content"]!=null && error["error"]["content"] == "alert_closed"){
            const modalRef = this.modalService.open(OkModalComponent, { size: 'lg' });
            modalRef.componentInstance.title = "Error";
            modalRef.componentInstance.message = this.translate.instant(error["error"]["content"]);
            this.translate.onLangChange.subscribe(() => {
                modalRef.componentInstance.title = "Error";
                modalRef.componentInstance.message = this.translate.instant(error["error"]["content"]);
            });
            modalRef.result.then(() => this.activeModal.close())
          }
          else{
            this.functionsService.errorHandler(error["status"]);
          }
        }
    );
  }

  get Note() { return this.controlGetter('Note'); }

  controlGetter(controlName) {
    const control =  this.addActivityForm.get(controlName);
    return control && (control.touched || this.formSubmitted) ? control : {};
  }
}
